import { useRecordCountQuery } from "./queries";

export function usePortfolioRecordCount(selectedBookId: string) {
  const recordsCountQuery = useRecordCountQuery(selectedBookId);

  return {
    recordCount: recordsCountQuery.data ?? 0,
    loading: recordsCountQuery.isLoading,
  };
}
